// Lib
import React, { ReactElement } from 'react';

// Components
import TiptapToggleMarkTool from './TiptapToggleMarkTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapInlineCodeTool = (props: ToolbarToolProps): ReactElement => <TiptapToggleMarkTool {...props} mark="code" />;

export default TiptapInlineCodeTool;
